import * as React from 'react';
import { FC } from 'react';

import { useIntl } from 'react-intl';

import { ItemActions } from 'components/item-actions';
import { ListItemGroup } from 'components/list-item-group';
import { RecentOrderCard } from 'components/recent-order-card-list-item';
import { useCdpContext } from 'state/cdp';
import { CustomEventNames, EventTypes } from 'state/cdp/constants';
import { useReorder } from 'state/order/hooks/use-reorder';

import { ReorderButton } from './favorite-card.styled';
import { IFavoriteCardProps } from './types';

/**
 *
 * FavoriteCard purpose
 *
 */
export const FavoriteCard: FC<IFavoriteCardProps> = ({
  id,
  entries,
  name,
  onEditFavorite,
  onRemoveFavorite,
}) => {
  const favoriteOrder = {
    cart: {
      cartEntries: entries,
      reorderCartEntries: entries,
      serviceMode: null,
      cartVersion: 1,
    },
  };

  const { formatMessage } = useIntl();
  const cdp = useCdpContext();

  const { handleReorderClick, disabled } = useReorder(favoriteOrder);

  const handleReorder = () => {
    for (const entry of favoriteOrder.cart.cartEntries) {
      cdp.trackEvent({
        name: CustomEventNames.ADD_FAVORITE_TO_CART,
        type: EventTypes.UserContent,
        attributes: {
          'Product Name': entry?.name,
          'User Location': 'Favorites Tab',
        },
      });
    }
    handleReorderClick();
  };

  if (!entries.length) {
    return null;
  }
  return (
    <ListItemGroup
      header={name || ''}
      headerAction={
        <ReorderButton data-testid="reorder-button" onClick={handleReorder} disabled={disabled}>
          {formatMessage({ id: 'orderNow' })}
        </ReorderButton>
      }
      items={entries.map(entry => (
        <RecentOrderCard key={entry?.lineId} cartEntry={entry} isOnFavoriteSection />
      ))}
      footer={
        <ItemActions
          onEdit={() => onEditFavorite(id ?? '')}
          onRemove={() => onRemoveFavorite(id ?? '')}
        />
      }
      key={id}
    />
  );
};
